'use client';

import React, { useState, useEffect, useRef } from 'react';
import Toast from './Toast';

const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);
  const isClientRef = useRef(false);

  // Add toast function
  const addToast = (message, type = 'success', duration = 5000) => {
    const id = Date.now() + Math.random();
    const newToast = {
      id,
      message,
      type,
      duration
    };
    
    setToasts(prevToasts => [...prevToasts, newToast]);
  };

  // Remove toast function
  const removeToast = (id) => {
    setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id));
  };

  // Check for messages in localStorage when component mounts
  useEffect(() => {
    // Set client flag to true when component mounts
    isClientRef.current = true;
    
    // Only access localStorage and window on the client side
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      // Check for logout message
      const logoutMessage = localStorage.getItem('logoutMessage');
      if (logoutMessage) {
        addToast(logoutMessage, 'success');
        localStorage.removeItem('logoutMessage');
      }
      
      // Check for login message
      const loginMessage = localStorage.getItem('loginMessage');
      if (loginMessage) {
        addToast(loginMessage, 'success');
        localStorage.removeItem('loginMessage');
      }
      
      // Check for registration message
      const registerMessage = localStorage.getItem('registerMessage');
      if (registerMessage) {
        addToast(registerMessage, 'success');
        localStorage.removeItem('registerMessage');
      }
      
      // Listen for custom toast events
      const handleAddToast = (event) => {
        const { message, type, duration } = event.detail;
        addToast(message, type, duration);
      };
      
      window.addEventListener('addToast', handleAddToast);
      
      return () => {
        window.removeEventListener('addToast', handleAddToast);
      };
    }
  }, []);

  // Don't render anything on the server
  if (!isClientRef.current) {
    return null;
  }

  return (
    // Updated positioning to work better on mobile
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50 space-y-2 sm:w-auto w-[calc(100%-2rem)] sm:left-1/2 sm:-translate-x-1/2">
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
};

// Add methods to global window object for easy access
if (typeof window !== 'undefined') {
  window.addToast = (message, type = 'success', duration = 5000) => {
    const event = new CustomEvent('addToast', { detail: { message, type, duration } });
    window.dispatchEvent(event);
  };
}

export default ToastContainer;